module.exports = __webpack_public_path__ + "static/media/sculptureExplore.7ce09136.png";